import React from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import HolidayCalendarPanel from './HolidayCalendarPanel';
import PayCodeApprovalPanel from './PayCodeApprovalPanel';
import PayrollExportProfilePanel from './PayrollExportProfilePanel';
import TimesheetOperationsPanel from './TimesheetOperationsPanel';
import AttendanceList from './AttendanceList';

const OperationsTimeAttendance = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('OPERATIONS');

  const tabs = [
    { key: 'OPERATIONS', label: t('operations_time_tab_puantaj', 'Puantaj'), icon: '⏱' },
    { key: 'SCHEDULES', label: t('operations_time_tab_schedules', 'Mesai Planları'), icon: '◷' },
    { key: 'DEPARTMENTS', label: t('operations_time_tab_departments', 'Departman Atamaları'), icon: '🏢' },
    { key: 'OVERRIDES', label: t('operations_time_tab_overrides', 'Personel İstisnası'), icon: '👤' },
    { key: 'REPORTS', label: t('operations_time_tab_reports', 'Bordro Raporu'), icon: '▤' },
    { key: 'TIMESHEET_SETTINGS', label: t('operations_time_tab_settings', 'Puantaj Ayarları'), icon: '⚙' },
  ];

  return <div className="space-y-6">
    <nav className="flex flex-wrap gap-2 rounded-2xl border border-slate-200 bg-white p-2 shadow-sm" aria-label={t('operations_time_tabs', 'Zaman devamlılık sekmeleri')}>
      {tabs.map((tab) => (
        <button
          key={tab.key}
          type="button"
          onClick={() => setActiveTab(tab.key)}
          className={`flex items-center gap-2 rounded-xl px-4 py-3 text-sm font-bold transition ${activeTab === tab.key ? 'bg-cyan-600 text-white shadow-md' : 'text-slate-600 hover:bg-cyan-50 hover:text-cyan-700'}`}
        >
          <span aria-hidden="true">{tab.icon}</span>
          {tab.label}
        </button>
      ))}
    </nav>

    {activeTab === 'OPERATIONS' && <AttendanceList initialView="ATTENDANCE" hideTabs />}

    {activeTab === 'SCHEDULES' && <AttendanceList initialView="SCHEDULES" hideTabs />}
    {activeTab === 'DEPARTMENTS' && <AttendanceList initialView="DEPARTMENTS" hideTabs />}
    {activeTab === 'OVERRIDES' && <AttendanceList initialView="OVERRIDES" hideTabs />}
    {activeTab === 'REPORTS' && <AttendanceList initialView="REPORTS" hideTabs />}
    {activeTab === 'TIMESHEET_SETTINGS' && <>
      <HolidayCalendarPanel t={t} />
      <PayCodeApprovalPanel t={t} />
      <TimesheetOperationsPanel t={t} />
      <PayrollExportProfilePanel t={t} />
    </>}
  </div>
};

export default OperationsTimeAttendance;
